import { create } from "zustand";
import { persist, PersistStorage } from "zustand/middleware";

interface AuthState {
    accessToken: string | null;
    refreshToken: string | null;
    m_email: string | null;
    m_mobile: string | null;
    m_id: string | null;
    m_level: number | null;
    m_name: string | null;
    customer_idx: number | null;
    customer_name: string | null;
    m_category: number | null;
    member_idx: number | null;
    setAuth: (data: Partial<AuthState>) => void;
    clearAuth: () => void;
}

const customStorage: PersistStorage<AuthState> = {
    getItem: name => {
        const item = localStorage.getItem(name);
        return item ? JSON.parse(item) : null;
    },
    setItem: (name, value) => {
        localStorage.setItem(name, JSON.stringify(value));
    },
    removeItem: name => {
        localStorage.removeItem(name);
    },
};

export const useAuthStore = create(
    persist<AuthState>(
        set => ({
            accessToken: null,
            refreshToken: null,
            m_email: null,
            m_mobile: null,
            m_id: null,
            m_level: null,
            m_name: null,
            member_idx: null,
            customer_idx: null,
            customer_name: null,
            m_category: null,
            setAuth: data => set(state => ({ ...state, ...data })),
            clearAuth: () =>
                set({
                    accessToken: null,
                    refreshToken: null,
                    m_email: null,
                    m_mobile: null,
                    m_id: null,
                    m_level: null,
                    m_name: null,
                    member_idx: null,
                    customer_idx: null,
                    customer_name: null,
                    m_category: null,
                }),
        }),
        {
            name: "user-auth-storage",
            storage: customStorage,
        },
    ),
);
